import React from "react";
import { Box, TextField, Typography } from "@mui/material";

const ACHIEVEMENT_PLACEHOLDER = [
  "・ポートフォリオURL",
  "・GitHubアカウントURL",
  "・制作実績URL（LP／コーポレートサイト等）",
  "・技術ブログURL（Qiita・Zenn・note・個人ブログなど）",
  "・登壇資料・発表実績URL",
  "・コミュニティ運営・イベント主催実績 など",
  "",
  "※可能であれば担当範囲や成果もあわせてご記入ください。",
].join("\n");

export default function AchievementForm({ formData, onChange }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  const characterCount = formData.achievement ? formData.achievement.length : 0;

  return (
    <Box>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        自己実績
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={8}
        id="achievement"
        name="achievement"
        value={formData.achievement || ""}
        onChange={handleChange}
        placeholder={ACHIEVEMENT_PLACEHOLDER}
        variant="outlined"
        margin="normal"
        helperText={`${characterCount}文字`}
        FormHelperTextProps={{
          sx: {
            textAlign: "right",
            marginRight: "0",
          },
        }}
        sx={{
          "& textarea:focus": {
            boxShadow: "none",
          },
        }}
      />
    </Box>
  );
}
